import React, { Component } from 'react';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './GAME.css';

import Photos from '.././components/Photos';
import Videos from '.././components/Videos';
import VideoStreamTV from '../components/VideoStreamTV';

import { FilterView, BannerShimmer, SetTournGameModal, ItemPicker, Modal, EmptyState, LoadingState, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PlayOffView, InputField } from '.././components/Common';
import { SplitPanel, MomentView, MomentTextView, TimeLineFilter, TimeLineForm, TimeLineSlider, StatView } from '.././components/GAME'
let mainStore = {
  game: { id: null },
  getGame: function () {
    return this.game
  },
  setGame: function (game) {
    this.game = game
    return this
  }
}

const {EventSource} = window;

export default class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'timeline',
      tabs: [
        { val: "summary", key: "Summary" },
        { val: "timeline", key: "Timeline" },
        { val: "stats", key: "Team Stats" },
        { val: "squad", key: "Squad" },
        { val: "photos", key: "Photos" },
        { val: "videos", key: "Videos" }
      ],
      game: { id: null },
      posts: [],
      gmc: {},
      summary: [],
      stats: {},
      textSummary: [],
      yourPhotos: [],
      photosOfYou: [],
      albums: [],
      yourVideos: [],
      videosOfYou: [],
      user: FakeData.getData("yoo"),
      offset: 0,
      box: { x: 0 },
      isLoadingPosts : true
    }
    this.setTab = this.setTab.bind(this)
    this.getGame = this.getGame.bind(this)
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    FakeData.mountState("game", true)
    this._isMounted = true;
    clearInterval(this.gameTimer)
    this.initGameService()
    this.initGamePostsService()
    this.getYourPhotos()
    this.getPhotosOf()
    this.getVideoOf()
    this.getYourVideos()
    this.getIOSocket()
    document.querySelector("#root").addEventListener('scroll', this.onScroll);
  }

  getIOSocket = () => {
    const _that = this;
    try {
      this.io = new window.io.connect(FakeData.apiURL+"/wsGMC", { transports: ['websocket'] });
      this.io.on("io_connected", (data) => {
        _that.io.emit("join", FakeData.getData("yoo"));
      });

      this.io.on("kill", (data) => {
        _that.io = false;
      })
    } catch (error) {
      this.io = false
    }
  }

  componentWillUnmount() {
    FakeData.mountState("game", false)
    this._isMounted = false;
    if(this.posts_system){
      this.posts_system.close();
    }

    if(this.system){
      this.system.close()
    }
    this.io = false;
    document.querySelector("#root").removeEventListener('scroll', this.onScroll);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.match.params.id !== nextProps.match.params.id || this.props.location.search !== nextProps.location.search) {
      const _that = this
      FakeData.mountState("game", false)
      this._isMounted = false;
      this.setState({
        game: { id: null },
        posts: [],
        gmc: {},
        summary: [],
        stats: {},
        textSummary: [],
      });

      setTimeout((() => {
        FakeData.mountState("game", true)
        _that._isMounted = true;
        _that.initGameService()
        _that.initGamePostsService();
        _that.getYourPhotos()
        _that.getPhotosOf()
        _that.getVideoOf()
        _that.getYourVideos()
        var params = FakeData.getQueries(nextProps.location.search);
        _that.setState({ activeTab: (params.sInit) ? params.sInit : "timeline" });
      }), 1000)

      return true;
    }

    if (this.props.location.search !== nextProps.location.search) {
      var params = FakeData.getQueries(nextProps.location.search);
      this.setState({ activeTab: params.sInit });
    }

    return true
  }

  getYourPhotos() {
    const _that = this
    const dataTo = {
      user: FakeData.getData("yoo"),
      userTo: {
        id: this.state.game.id,
        type: "G",
      }
    }

    FakeData.post("/getPhotos.php?auth0&yours", dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }

        //console.log(res)
        _that.setState({
          yourPhotos: res
        })

        //FakeData.setData("user_photos", res)

        _that.getEventsID = setTimeout((() => {
          _that.getYourPhotos()
        }), 3000)
      }),
      error: ((res) => {

      })
    })
  }

  getPhotosOf() {
    const _that = this
    const dataTo = {
      user: FakeData.getData("yoo"),
      userTo: {
        id: this.state.game.id,
        type: "G",
      }
    }

    FakeData.post("/getPhotos.php?auth0", dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        _that.setState({
          photosOfYou: res
        })

        _that.getEventsID = setTimeout((() => {
          _that.getPhotosOf()
        }), 1500)
      }),
      error: ((res) => {

      })
    })
  }

  getYourVideos() {
    const _that = this
    const dataTo = {
      user: FakeData.getData("yoo"),
      userTo: {
        id: this.state.game.id,
        type: "G",
      }
    }

    FakeData.post("/getVideos.php?auth0&yours", dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        _that.setState({
          yourVideos: res
        })

        //FakeData.setData("user_photos", res)

        _that.getEventsID = setTimeout((() => {
          _that.getYourVideos()
        }), 3000)
      }),
      error: ((res) => {

      })
    })
  }

  getVideoOf() {
    const _that = this
    const dataTo = {
      user: FakeData.getData("yoo"),
      userTo: {
        id: this.state.game.id,
        type: "G",
      }
    }

    FakeData.post("/getVideos.php?auth0", dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        _that.setState({
          videosOfYou: res
        })

        _that.getEventsID = setTimeout((() => {
          _that.getVideoOf()
        }), 1500)
      }),
      error: ((res) => {
        console.log("EEor", res)
        _that.getEventsID = setTimeout((() => {
          _that.getVideoOf()
        }), 3000)
      })
    })
  }

  onScroll(e) {
    this.setState({
      offset: e.target.scrollTop
    });

    //console.log(e.target.scrollTop);
  }

  initGameService = () => {
    if (EventSource) {
      this.system = new EventSource(
        FakeData.fetchURL+
          "/getPublicGame.php?auth0&event_update&userId=" +
          FakeData.getData("yoo").id +
          "&gameId=" +
          this.props.match.params.id
      );
      const _that = this;
      if (this.system !== null) {
        //this.system.addEventListener()
        this.system.onmessage = function(e) {
          
        };

        this.system.addEventListener(
          "open",
          function(e) {
            // Connection was opened.
            //console.log(e)
          },
          false
        );

        this.system.addEventListener(
          "game_update",
          function(e) {
            // Connection was opened.
            if (_that._isMounted) {
              const data = JSON.parse(e.data);
              _that.setState({
                game: data.core,
                gmc: data.gmc,
                summary: data.summary,
                stats: data.stats,
                textSummary: data.textSummary
              });
            }
          },
          false
        );

        this.system.addEventListener(
          "error",
          function(e) {
            if (e.readyState == EventSource.CLOSED) {
              // Connection was closed.
            }
          },
          false
        );
      }
    } else {
      console.warn("EventSource Streams not supoorted by browser");
      this.getGame();
    }
  }

  getGame() {
    const _that = this
    const User = FakeData.getData("yoo")
    const dataTo = {
      userId: User.id,
      gameId: this.props.match.params.id
    }

    FakeData.post('/getPublicGame.php?auth0', dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        const data = res
        _that.setState({
          game: data.core,
          gmc: data.gmc,
          summary: data.summary,
          stats: data.stats,
          textSummary: data.textSummary
        });

        setTimeout(() => {
          _that.getGame()
        }, 3000)
      }),
      error: ((err) => {
        setTimeout(() => {
          _that.getGame()
        }, 3000)
      })
    })
  }

  initGamePostsService = () => {
    if (EventSource) {
      this.posts_system = new EventSource(
        FakeData.fetchURL+
          "/getPublicGamePosts.php?auth0&event_update&userId=" +
          FakeData.getData("yoo").id +
          "&gameId=" +
          this.props.match.params.id
      );
      const _that = this;
      if (this.posts_system !== null) {
        //this.system.addEventListener()
        this.posts_system.onmessage = function(e) {
          
        };

        this.posts_system.addEventListener(
          "open",
          function(e) {
            // Connection was opened.
            //console.log(e)
          },
          false
        );

        this.posts_system.addEventListener(
          "posts_update",
          function(e) {
            // Connection was opened.
            if (_that._isMounted) {
              const data = JSON.parse(e.data);
              _that.setState({
                posts: data,
                isLoadingPosts: false
              });
            }
          },
          false
        );

        this.posts_system.addEventListener(
          "error",
          function(e) {
            if (e.readyState == EventSource.CLOSED) {
              // Connection was closed.
            }
          },
          false
        );
      }
    } else {
      console.warn("EventSource Streams not supoorted by browser");
      this.getGamePosts();
    }
  }

  getGamePosts() {
    const _that = this
    const User = FakeData.getData("yoo")
    const dataTo = {
      userId: User.id,
      gameId: this.props.match.params.id
    }

    FakeData.post('/getPublicGamePosts.php?auth0', dataTo, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        const data = res
        _that.setState({
          posts: data,
          isLoadingPosts: false
        });

        setTimeout(() => {
          _that.getGamePosts()
        }, 1000)
      }),
      error: ((err) => {
        _that.setState({
          posts: [],
          isLoadingPosts: false
        });
      })
    })
  }

  onPostAdded(post) {
    //console.log(this.state.posts.length);
    this.state.posts.unshift(post)
    this.setState({
      posts: this.state.posts
    });

    //console.log(this.state.posts.length);
  }

  setTab(item) {
    this.setState({
      activeTab: item.val
    })
  }

  render() {
    if (this.state.game.id === null) {
      return (
        <BannerShimmer />
      );
    }

    if (this.state.game.error) {
      return (
        <div className="gmc-before">
          <div className="loader">
            <h1>Please wait...</h1>
            <div className="spinner"></div>
          </div>
        </div>
      );
    }

    /*if(!this.is){
      return(
        <BannerShimmer />
      )
    }*/

    return (
      <div className="tabs game row main_content sp-flex-width">
        <GameBanner isLoadingPosts={this.state.isLoadingPosts} onPostAdded={this.onPostAdded.bind(this)} box={this.state.box} onMount={(box) => this.setState({ box })} offset={this.state.offset} user={this.state.user} gmc={this.state.gmc} posts={this.state.posts} game={this.state.game} activeTab={this.state.activeTab} onTabSelect={this.setTab} tabs={this.state.tabs} />
        <TabViews isLoadingPosts={this.state.isLoadingPosts} box={this.state.box} photosOfYou={this.state.photosOfYou} yourPhotos={this.state.yourPhotos} albums={[]} yourVideos={this.state.yourVideos} videosOfYou={this.state.videosOfYou} onPostAdded={this.onPostAdded.bind(this)} offset={this.state.offset} stats={this.state.stats} summary={this.state.summary} textSummary={this.state.textSummary} user={this.state.user} gmc={this.state.gmc} posts={this.state.posts} game={this.state.game} activeTab={this.state.activeTab} />
      </div>
    );
  }
}

class TabLabels extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const items = this.props.tabs;

    return (
      <div className="game-banner-nav">
        {items.map((item, i) =>
          <div key={i} onClick={() => this.props.onTabSelect(item)} className={(this.props.activeTab === item.val) ? 'nav-game active' : 'nav-game'}>{item.key}</div>
        )}
      </div>
    );
  }
}

class TabViews extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="game-views">
        {(this.props.activeTab === "summary") ? (<GameSummary textSummary={this.props.textSummary} offset={this.props.offset} summary={this.props.summary} user={this.props.user} game={this.props.game} uniq={this.props.activeTab} />) :
          (this.props.activeTab === "timeline") ? (<GameTimeLine isLoadingPosts={this.props.isLoadingPosts} box={this.props.box} onPostAdded={this.props.onPostAdded} offset={this.props.offset} user={this.props.user} posts={this.props.posts} game={this.props.game} acts={this.props.gmc.allActs} posts={this.props.posts} uniq={this.props.activeTab} />) :
            (this.props.activeTab === "stats") ? (<GameStats offset={this.props.offset} stats={this.props.stats} game={this.props.game} />) :
              (this.props.activeTab === "squad") ? (<GameSquad offset={this.props.offset} user={this.props.user} game={this.props.game} uniq={this.props.activeTab} />) :
                (this.props.activeTab === "photos") ? (<GamePhotos offset={this.props.offset} user={this.props.user} game={this.props.game} uniq={this.props.activeTab} yourPhotos={FakeData.listify(this.props.yourPhotos)} photosOfYou={FakeData.listify(this.props.photosOfYou)} albums={FakeData.listify(this.props.albums)} isAdmin={FakeData.getData("yoo").id === this.props.game.matchAdmin.id ? true : false} />) :
                  (<GameVideos offset={this.props.offset} user={this.props.user} uniq={this.props.activeTab} game={this.props.game} yourVideos={FakeData.listify(this.props.yourVideos)} videosOfYou={FakeData.listify(this.props.videosOfYou)} isAdmin={FakeData.getData("yoo").id === this.props.game.matchAdmin.id ? true : false} />)}
      </div>
    );
  }
}

class GameBanner extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasScrolled: false,
      user: false,
      filter: "",
    }
  }

  componentDidMount() {
    this.props.onMount(document.querySelector(".game-banner").getBoundingClientRect());
  }
  componentDidUpdate(nextProps, nextState) {
    //this.props.onMount({ box: document.querySelector(".game-banner").getBoundingClientRect() });
  }

  setFilter(fil, user = false) {
    this.setState({
      filter: fil,
      user
    });
  }

  getData = (fil, user = false) => {
    if (fil === "") {
      return FakeData.listify(this.props.posts)
    } else {
      let newArr = [];
      if(!user){
        newArr = FakeData.listify(this.props.posts).filter((item,i)=>{
          return item.type.toLowerCase().indexOf(fil.toLowerCase()) > -1;
        })
      } else{
        newArr = FakeData.listify(this.props.posts).filter((item,i)=>{
          return item.type.toLowerCase().indexOf(fil.toLowerCase()) > -1 && (item.user.id === user.id || item.user.id === FakeData.getData("yoo").id);
        })
      }

      return newArr;
    }
  }

  render() {
    return (
      <div className="game-banner" ref={"root"}>
        <img src=".././images/real_time_cover.jpg" />
        <div className="game-banner-info">
          <div className="score">
            <GameBannerTeam user={this.props.user} goals={this.props.gmc.teamOneGoals} game={this.props.game} team={this.props.game.teamOne} class="" />
            <GameBannerScore user={this.props.user} goals={this.props.gmc} game={this.props.game} />
            <GameBannerTeam user={this.props.user} goals={this.props.gmc.teamTwoGoals} game={this.props.game} team={this.props.game.teamTwo} class="reverse" />
          </div>
          <div className="realtime-slider">
            <GameBannerSlider user={this.props.user} game={this.props.game} teamOneActs={this.props.gmc.teamOneActs} teamTwoActs={this.props.gmc.teamTwoActs} gameProgress={this.props.game.currentTime} maxLength={(this.props.game.duration * 60)} />
            <GameBannerSliderTimeline user={this.props.user} />
            <GameBannerSliderTimelineValues user={this.props.user} game={this.props.game} />
          </div>
        </div>
        <GameVideoView user={this.props.game} setHasScrolled={()=>{
          this.setState({ hasScrolled: !this.state.hasScrolled });
        }} gameBannerSlider={
          <div className="realtime-slider">
            <GameBannerSlider user={this.props.user} game={this.props.game} teamOneActs={this.props.gmc.teamOneActs} teamTwoActs={this.props.gmc.teamTwoActs} gameProgress={this.props.game.currentTime} maxLength={(this.props.game.duration * 60)} />
            <GameBannerSliderTimeline user={this.props.user} />
            <GameBannerSliderTimelineValues user={this.props.user} game={this.props.game} />
          </div>
        }
        scoreBoard={
          <div className="embedded-score-board">
            <div className="embedded-score-board-item">
              <span className="embedded-score-board-item-name">{this.props.game.teamOne.name}</span>
              <img className="embedded-score-board-item-img" src={this.props.game.teamOne.image}/>
              <span className="embedded-score-board-item-score">{this.props.gmc.teamOneGoals.length}</span>
            </div>
            -
            <div className="embedded-score-board-item">
              <span className="embedded-score-board-item-score">{this.props.gmc.teamTwoGoals.length}</span>
              <img className="embedded-score-board-item-img" src={this.props.game.teamTwo.image}/>
              <span className="embedded-score-board-item-name">{this.props.game.teamTwo.name}</span>
            </div>
          </div>
        }
        timeLineForm={
          <GameTimeLine view="comments" onOverlayClose={()=>{
            this.setState({ hasScrolled: false });
          }} hasScrolled={this.state.hasScrolled} formOnly={true} isLoadingPosts={this.props.isLoadingPosts} box={this.props.box} onPostAdded={(post)=>{
            this.setState({ hasScrolled: false });
            this.props.onPostAdded(post)
          }} offset={this.props.offset} user={this.props.user} posts={this.getData(this.state.filter, this.state.user)} game={this.props.game} acts={this.props.gmc.allActs} posts={this.props.posts} uniq={this.props.activeTab} />
        } timeLine={
          <GameTimeLine view="comments" isLoadingPosts={this.props.isLoadingPosts} box={this.props.box} onPostAdded={this.props.onPostAdded} offset={this.props.offset} user={this.props.user} posts={this.getData(this.state.filter, this.state.user)} game={this.props.game} acts={this.props.gmc.allActs} posts={this.props.posts} uniq={this.props.activeTab} />
        } filter={
          <GameTimeLine view="filter" setFilter={(fil, user)=>{
            this.setFilter(fil, user);
          }} isLoadingPosts={this.props.isLoadingPosts} box={this.props.box} onPostAdded={this.props.onPostAdded} offset={this.props.offset} user={this.props.user} posts={this.getData(this.state.filter, this.state.user)} game={this.props.game} acts={this.props.gmc.allActs} posts={this.props.posts} uniq={this.props.activeTab} />
        }/>
        <TabLabels user={this.props.user} activeTab={this.props.activeTab} onTabSelect={this.props.onTabSelect} tabs={this.props.tabs} />
      </div>
    );
  }
}

class GameVideoView extends Component{
  constructor(props){
    super(props)
    this.state = {
      isExpanded: false,
      video: null,
      isError: false,
      isLoading: true
    }
  }

  componentDidMount(){
    this._isMounted = true;
    this.getVidData(this.getNewKey);
  }

  componentWillUnmount(){
    this._isMounted = false
  }

  getNewKey = () => {
    var user = this.props.user.teamOne.squadId;
    var mid = new Date(this.props.user.fullDate).getTime();
    var end = this.props.user.teamTwo.squadId;
    var str = user + "" + mid + "" + end;
    var id = str;
    return id;
  };

  getVidData = (id) => {
    const _that = this;
    FakeData.post(
      "http://supotsu.com:2018/get/" + id,
      {},
      {
        success(res) {
          if (!_that._isMounted) {
            return;
          }

          if (!res.error) {
            _that.setState({ video: res, isLoading: false });
          } else{
            _that.setState({ isError: true, isLoading: false });
          }
        },
        error(res) {
          _that.setState({ isError: true, isLoading: false });
        }
      }
    );
  };

  render(){
    const {} = this.props;
    const {isExpanded, isError, isLoading} = this.state;
    if(isLoading){
      return null;
    }
    if(isError){
      return null;
    }
    return(
      <div className={isExpanded?"game-has-live-video full-view":"game-has-live-video"} onClick={()=>{
        if(isExpanded){
          return;
        }
        this.setState({ isExpanded:true });
      }}>
          {!isExpanded &&
            <img src={""} style={{
              width: "100%",
              height: "100%"
            }} />
          }
          {isExpanded && <VideoStreamTV scoreBoard={this.props.scoreBoard} filter={this.props.filter} gameBannerSlider={this.props.gameBannerSlider} timeLine={this.props.timeLine} isPlayOnly={true} videoId={this.getNewKey()} onClose={()=>{
            this.setState({ isExpanded:false });
          }}/>}
          {isExpanded && this.props.timeLineForm}
          {isExpanded && 
            <div className={"fab-post active"} style={{
              justifyContent: 'flex-end',
              marginBottom: "100px"
            }}>
              <img src=".././images/comment_icon_wht.svg" onClick={this.props.setHasScrolled} />
            </div>
          }
      </div>
    )
  }
}

class GameBannerTeam extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const goals = this.props.goals
    return (
      <div className="score-team">
        <div className={"score-team-info " + this.props.class}>
          <img src={this.props.team.image} />
          <span>{this.props.team.name}</span>
        </div>
        <div className={"score-team-goals " + this.props.class}>
          {
            goals.map((goal, i) =>
              <div key={i} className={"score-team-goal " + this.props.class}>
                <span className="minutes">{goal.min}</span>
                <span className="name">{goal.player.name}</span>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

class GameBannerScore extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="score-output">
        <div className="one">{this.props.goals.teamOneGoals.length}-{this.props.goals.teamTwoGoals.length}</div>
        <div className="two">{Math.floor(this.props.game.currentTime / 60)}</div>
        <div className="three">{this.props.game.matchPlace}</div>
      </div>
    );
  }
}

class GameBannerSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      max: this.props.maxLength,
      progress: this.props.gameProgress
    }
  }

  componentWillMount() {

  }

  render() {
    const teamOneActs = this.props.teamOneActs
    const teamTwoActs = this.props.teamTwoActs
    return (
      <div className="slider-holder">
        <div className="slider-team-logos">
          <img src={this.props.game.teamOne.image} />
          <img src={this.props.game.teamTwo.image} />
        </div>
        <div className="slider-for">
          <div className="indicators">
            {
              teamOneActs.map((item, i) =>
                <div className="indicator" key={i} style={{ marginLeft: Math.floor(((item.min / this.state.max) * 100)) + "%" }}><img src={item.image} /></div>
              )
            }
          </div>
          <div className="range">
            <div className="pin" style={{ width: ((this.state.progress / this.state.max) * 100) + "%" }}></div>
          </div>
          <div className="indicators">
            {
              teamTwoActs.map((item, i) =>
                <div className="indicator" key={i} style={{ marginLeft: Math.floor(((item.min / this.state.max) * 100)) + "%" }}><img src={item.image} /></div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
}

class GameBannerSliderTimeline extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="slider-timeline">
        <div className="timeline-dot"></div>
        <div className="timeline-dot"></div>
        <div className="timeline-dot"></div>
        <div className="timeline-dot"></div>
        <div className="timeline-dot"></div>
        <div className="timeline-dot"></div>
      </div>
    );
  }
}

class GameBannerSliderTimelineValues extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const halfTime = this.props.game.matchHalf
    const firstQ = Math.floor(halfTime / 3)
    return (
      <div className="slider-values">
        <div className="values-dot">0</div>
        <div className="values-dot">{firstQ}</div>
        <div className="values-dot">{halfTime - firstQ}</div>
        <div className="values-dot">HT</div>
        <div className="values-dot">{halfTime + firstQ}</div>
        <div data-val={halfTime + (halfTime - firstQ)} className="values-dot"></div>
      </div>
    );
  }
}

export class GameSummary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: "graphic",
      activeTeam: { name: "" },
      activePlayer: { name: "" },
      players: [],
      isLoading: false,
      data: { profile: { id: null }, stats: {} },
      error: false
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillMount() {
    this._isMounted = false;
  }

  loadPlayer = (player, game, team) => {
    const _that = this;
    if (!this._isMounted) {
      return
    }

    FakeData.post("/getPlayerProfile.php?auth0", {
      playerId: player.id,
      gameId: game.id,
      teamId: team.id
    }, {
        success: ((res) => {
          if (!_that._isMounted) {
            return
          }

          if (res.error && _that._isMounted) {
            _that.setState({
              error: true
            });
          } else if (_that._isMounted) {
            _that.setState({
              data: res,
              isLoading: false
            });
          }
        }),
        error: ((err) => {
          _that.setState({
            error: true
          });
        })
      })
  }

  render() {
    const { isEmbed, game } = this.props;
    const { activePlayer, activeTeam, players, isLoading, data, error } = this.state;
    const _teamOneName = game.teamOne.name;
    if (isEmbed) {
      return (
        <div className="summary-view">
          <div className="summary-tabs">
            <div className={(this.state.activeTab === "graphic") ? "summary-tab active" : "summary-tab"} onClick={() => this.setState({ activeTab: "graphic" })}>Graphic Summary</div>
            <div className={(this.state.activeTab === "text") ? "summary-tab active" : "summary-tab"} onClick={() => this.setState({ activeTab: "text" })}>Text Summary</div>
            <div className={(this.state.activeTab === "stat") ? "summary-tab active" : "summary-tab"} onClick={() => this.setState({ activeTab: "stat" })}>Player Summary</div>
          </div>
          <div className="summary-view-group" style={{ marginTop: "10px" }}>
            <div className={(this.state.activeTab === "graphic") ? "view-group active" : "view-group"}>
              <div className="moment-views">
                {
                  this.props.summary.map((item, i) =>
                    <MomentView item={item} key={i} />
                  )
                }
              </div>
            </div>
            <div className={(this.state.activeTab === "text") ? "view-group active" : "view-group"}>
              <div className="text-moment-views">
                {
                  this.props.textSummary.map((item, i) =>
                    <MomentTextView item={item} isOdd={(i % 2 != 0) ? false : true} key={i} />
                  )
                }
              </div>
            </div>
            <div className={(this.state.activeTab === "stat") ? "view-group active" : "view-group"}>
              <div className="split-input">
                <InputField label="Team">
                  <select className="normal-input" value={activeTeam.name} style={{ border: "1px solid #aaa" }} onChange={(e) => {
                    if (e.target.value === "") {
                      this.setState({
                        activeTeam: { name: "" },
                        activePlayer: { name: "" },
                        players: []
                      });
                    } else {
                      if (_teamOneName === e.target.value) {
                        this.setState({
                          activeTeam: game.teamOne,
                          activePlayer: { name: "" },
                          players: FakeData.listify(game.teamOne.lineup).concat(FakeData.listify(game.teamOne.subs))
                        });
                      } else {
                        this.setState({
                          activeTeam: game.teamTwo,
                          activePlayer: { name: "" },
                          players: FakeData.listify(game.teamTwo.lineup).concat(FakeData.listify(game.teamTwo.subs))
                        });
                      }
                    }
                  }}>
                    <option value="">Select team</option>
                    <option value={game.teamOne.name}>{game.teamOne.name}</option>
                    <option value={game.teamTwo.name}>{game.teamTwo.name}</option>
                  </select>
                </InputField>
                <InputField label="Player">
                  <select className="normal-input" style={{ border: "1px solid #aaa" }} disabled={activeTeam.name !== "" ? false : true} onChange={(e) => {
                    if (e.target.value === "") {
                      this.setState({
                        activePlayer: { name: "" },
                        isLoading: false
                      });
                    } else {
                      const _players = players.filter((item, i) => {
                        return item.id === e.target.value;
                      })

                      this.setState({
                        activePlayer: _players[0],
                        isLoading: true
                      });

                      this.loadPlayer(_players[0], game, activeTeam);
                    }
                  }}>
                    <option value="">Select player</option>
                    {
                      players.map((item, i) => {
                        return (<option key={item.name + item.id} value={item.id}>{item.name}</option>)
                      })
                    }
                  </select>
                </InputField>
              </div>
              <div>
                {!isLoading && activePlayer.name === "" &&
                  <EmptyState icon="person" text={"No player selected!"} isShown={true} style={{ width: "100%", height: "100%" }} />
                }

                {activePlayer.name !== "" && isLoading &&
                  <LoadingState isShown={true} text={"Loading"} style={{ width: "100%", height: "100%" }} />
                }
                {activePlayer.name !== "" && !isLoading &&
                  <SportPlayedView profile={data.profile} game={game} team={activeTeam} stats={data.stats} player={activePlayer} />
                }
              </div>
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className="game-view">
        <SplitPanel offset={this.props.offset}>
          <div className="summary-view">
            <div className="summary-tabs">
              <div className={(this.state.activeTab === "graphic") ? "summary-tab active" : "summary-tab"} onClick={() => this.setState({ activeTab: "graphic" })}>Graphic Summary</div>
              <div className={(this.state.activeTab === "text") ? "summary-tab active" : "summary-tab"} onClick={() => this.setState({ activeTab: "text" })}>Text Summary</div>
            </div>
            <div className="summary-view-group">
              <div className={(this.state.activeTab === "graphic") ? "view-group active" : "view-group"}>
                <div className="squads">
                  <div className="squad">
                    <div className="team"><img src={this.props.game.teamOne.image} /><h2>{this.props.game.teamOne.name}</h2></div>
                  </div>
                  <div className="squad">
                    <div className="team"><img src={this.props.game.teamTwo.image} /><h2>{this.props.game.teamTwo.name}</h2></div>
                  </div>
                </div>
                <div className="moment-views">
                  {
                    this.props.summary.map((item, i) =>
                      <MomentView item={item} key={i} />
                    )
                  }
                </div>
              </div>
              <div className={(this.state.activeTab === "text") ? "view-group active" : "view-group"}>
                <div className="text-moment-views">
                  {
                    this.props.textSummary.map((item, i) =>
                      <MomentTextView item={item} isOdd={(i % 2 != 0) ? false : true} key={i} />
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </SplitPanel>
      </div>
    );
  }
}

class SportPlayedView extends Component {
  constructor(p) {
    super(p)
    this.state = {
      startIndex: 0,
      endIndex: 7,
      //active: this.props.sports[0],
      activeTeam: null
    }
  }

  getSportGoalTerm(name) {
    const term = (name === "Rugby") ? "Tries" : (name === "Cricket") ? "Runs" : "Goals"
    return term
  }

  getTeams(sport, teams) {
    const arr = [];
    teams.forEach((item, i) => {
      if (item.sport === sport) {
        arr.push(item)
      }
    });

    return arr;
  }

  getStat = (_stat) => {
    return FakeData.listify(this.props.stats).filter((stat) => { return stat.action === _stat.toLowerCase() });
  }

  render() {
    const them = this.props.profile;
    const team = this.props.team;
    const player = this.props.player;
    const game = this.props.game;
    const subs = player.start > game.matchHalf ? (player.end) : (player.end - player.start);
    return (
      <div className="sport-played-view" style={{ width: "50%", margin: "0px 25%" }}>
        <div className="sport-played-view-body">
          <div className="sport-played-view-body-head">
            <div className="sport-played-view-body-head-item">
              <span>{this.getStat("goal").length}</span>
              <span>{this.getSportGoalTerm("Soccer")}</span>
            </div>
            <div className="sport-played-view-body-head-item">
              <span>1</span>
              <span>Matches</span>
            </div>
            <div className="sport-played-view-body-head-item">
              <span>{subs}</span>
              <span>Minutes</span>
            </div>
          </div>
          <div className="sport-played-view-body-body">
            <div className="sport-details">
              <div>
                <div className="sport-detail">
                  <span>Position</span>
                  <span>{this.props.player.position}</span>
                </div>
                <div className="sport-detail">
                  <span>Height</span>
                  <span>{them.basicInfo[3].value}</span>
                </div>
                <div className="sport-detail">
                  <span>Weight</span>
                  <span>{them.basicInfo[4].value}</span>
                </div>
                <div className="sport-detail">
                  <span>Age</span>
                  <span>{them.age}</span>
                </div>
                <div className="sport-detail">
                  <span>D.O.B</span>
                  <span>{them.dob}</span>
                </div>
                <div className="sport-detail">
                  <span>Nationality</span>
                  <span>{player.origin}</span>
                </div>
                <div className="sport-detail">
                  <span>Assists</span>
                  <span>{this.getStat("assist").length}</span>
                </div>

                <div className="sport-detail">
                  <span>Corners</span>
                  <span>{this.getStat("goal").length}</span>
                </div>
                <div className="sport-detail">
                  <span>Fouls</span>
                  <span>{this.getStat("foul").length}</span>
                </div>
                <div className="sport-detail">
                  <span>Offsides</span>
                  <span>{this.getStat("offside").length}</span>
                </div>
                <div className="sport-detail">
                  <span>Yellow Card</span>
                  <span>{this.getStat("yc").length}</span>
                </div>
                <div className="sport-detail">
                  <span>Red Card</span>
                  <span>{this.getStat("rc").length}</span>
                </div>
                <div className="sport-detail">
                  <span>Current Team</span>
                  <span>{team.name}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class GameTimeLine extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredData: FakeData.listify(this.props.posts),
      data: FakeData.listify(this.props.posts),
      user: false,
      filter: "",
      hasScrolled: false
    }
  }

  componentWillReceiveProps(nextProps) {
    //this.setFilter(this.state.filter, this.state.user)
  }

  setFilter(fil, user = false) {
    this.setState({
      filter: fil,
      user
    });

    if(this.props.setFilter){
      this.props.setFilter(fil, user)
    }
  }

  getData = (fil, user = false) => {
    const {view, formOnly, hasScrolled} = this.props;
    if(view==="filter"){
      return FakeData.listify(this.props.posts)
    }
    if (fil === "") {
      return FakeData.listify(this.props.posts)
    } else {
      let newArr = [];
      if(!user){
        newArr = FakeData.listify(this.props.posts).filter((item,i)=>{
          return item.type.toLowerCase().indexOf(fil.toLowerCase()) > -1;
        })
      } else{
        newArr = FakeData.listify(this.props.posts).filter((item,i)=>{
          return item.type.toLowerCase().indexOf(fil.toLowerCase()) > -1 && (item.user.id === user.id || item.user.id === FakeData.getData("yoo").id);
        })
      }

      return newArr;
    }
  }

  onOverlayClose() {
    this.setState({
      hasScrolled: false
    });
  }

  render() {
    const posts = this.getData(this.state.filter, this.state.user)
    const {view, formOnly, hasScrolled} = this.props;
    if(view==="comments" && formOnly){
      return(
        <TimeLineForm isFullScreen={true} formOnly={true} isLoadingPosts={this.props.isLoadingPosts} onPostAdded={this.props.onPostAdded} onOverlayClose={this.props.onOverlayClose} filter={this.state.filter} acts={this.props.acts} hasScrolled={hasScrolled} posts={posts} game={this.props.game} user={FakeData.getData("yoo")} offset={this.props.offset} />
      );
    }

    if(view==="comments"){
      return(
        <TimeLineForm isFullScreen={true} shrinkItems={true} isLoadingPosts={this.props.isLoadingPosts} onPostAdded={this.props.onPostAdded} onOverlayClose={() => this.onOverlayClose()} filter={this.state.filter} acts={this.props.acts} hasScrolled={this.state.hasScrolled} posts={posts} game={this.props.game} user={FakeData.getData("yoo")} offset={this.props.offset} />
      );
    }

    if(view==="filter"){
      return(
        <TimeLineFilter isEmbed={true} onFilter={(val, user = false) => this.setFilter(val, user)} posts={posts} game={this.props.game} user={this.props.user} offset={this.props.offset} />
      );
    }

    if(view==="fab"){
      return(
        <div className={"fab-post active"}>
          <img src=".././images/comment_icon_wht.svg" onClick={() => this.setState({
            hasScrolled: true
          })} />
        </div>
      );
    }

    return (
      <div className="game-view timeline-view">
        <TimeLineFilter onFilter={(val, user = false) => this.setFilter(val, user)} posts={posts} game={this.props.game} user={this.props.user} offset={this.props.offset} />
        <TimeLineForm isFullScreen={false} isLoadingPosts={this.props.isLoadingPosts} onPostAdded={this.props.onPostAdded} onOverlayClose={() => this.onOverlayClose()} filter={this.state.filter} acts={this.props.acts} hasScrolled={this.state.hasScrolled} posts={posts} game={this.props.game} user={FakeData.getData("yoo")} offset={this.props.offset} />
        <TimeLineSlider box={this.props.box} posts={posts} game={this.props.game} user={FakeData.getData("yoo")} acts={this.props.acts} offset={this.props.offset} />
        <div className={(this.props.offset >= 490) ? "fab-post active" : "fab-post"}>
          <img src=".././images/comment_icon_wht.svg" onClick={() => this.setState({
            hasScrolled: true
          })} />
        </div>
      </div>
    );
  }
}

class GameSquad extends React.Component {
  constructor(props) {
    super(props)
    //console.log(this.props);
  }

  render() {
    return (
      <div className="game-view">
        <SplitPanel offset={this.props.offset}>
          <div className="squads">
            <div className="squad">
              <div className="team"><img src={this.props.game.teamOne.image} /><h2>{this.props.game.teamOne.name}</h2></div>
              <div className="players-for-squad">
                {
                  this.props.game.teamOne.lineup.map((item, i) =>
                    <div className="player-for-this" key={i}>
                      <span>{item.name} ({item.number})</span>
                      <span>{item.position}</span>
                    </div>
                  )
                }
              </div>
            </div>
            <div className="squad">
              <div className="team"><img src={this.props.game.teamTwo.image} /><h2>{this.props.game.teamTwo.name}</h2></div>
              <div className="players-for-squad">
                {
                  this.props.game.teamTwo.lineup.map((item, i) =>
                    <div className="player-for-this" key={i}>
                      <span>{item.name} ({item.number})</span>
                      <span>{item.position}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </SplitPanel>
      </div>
    );
  }
}

class GameStats extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const teamOne = this.props.stats.teamOne
    const teamTwo = this.props.stats.teamTwo
    return (
      <div className="game-view">
        <SplitPanel offset={this.props.offset}>
          <div className="flexDown">
            <div className="squads">
              <div className="squad">
                <div className="team"><img src={this.props.game.teamOne.image} /><h2>{this.props.game.teamOne.name}</h2></div>
              </div>
              <div className="squad">
                <div className="team"><img src={this.props.game.teamTwo.image} /><h2>{this.props.game.teamTwo.name}</h2></div>
              </div>
            </div>
            <div className="stat-views">
              <StatView valueOne={teamOne.possesion} valueTwo={teamTwo.possesion} title="Possesion" />
              <StatView valueOne={teamOne.shots} valueTwo={teamTwo.shots} title="Shots At Goal" />
              <StatView valueOne={teamOne.fouls} valueTwo={teamTwo.fouls} title="Fouls" />
              <StatView valueOne={teamOne.corners} valueTwo={teamTwo.corners} title="Corners" />
              <StatView valueOne={teamOne.offside} valueTwo={teamTwo.offside} title="Offsides" />
              <StatView valueOne={teamOne.yc} valueTwo={teamTwo.yc} title="Yellow Cards" />
              <StatView valueOne={teamOne.rc} valueTwo={teamTwo.rc} title="Red Cards" />
            </div>
          </div>
        </SplitPanel>
      </div>
    );
  }
}

class GamePhotos extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const user = this.props.game;
    user['type'] = "G";
    user['isAdmin'] = this.props.isAdmin;
    return (
      <div className="game-view" style={{marginTop:"20px"}}>
        <Photos user={user} filterArray={["Albums"]} userType={"G"} author={"Game"} data={{ uploads: this.props.yourPhotos, tagged: this.props.photosOfYou, albums: this.props.albums }} isAdmin={this.props.isAdmin} />
      </div>
    );
  }
}

class GameVideos extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const user = this.props.game;
    user['type'] = "G";
    user['isAdmin'] = this.props.isAdmin;
    return (
      <div className="game-view" style={{marginTop:"20px"}}>
        <Videos user={user} userType={"G"} author={"Game"} data={{ uploads: this.props.yourVideos, tagged: this.props.videosOfYou }} isAdmin={this.props.isAdmin} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/GAME.js